import { createFileRoute } from '@tanstack/react-router';

import { CrochetIconsPage } from '@/pages/crochet-icons';

export const Route = createFileRoute('/crochet-icons/')({
    component: CrochetIconsPage,
});
